/* eslint-disable jsx-a11y/media-has-caption */
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import AudioPlayer from 'react-h5-audio-player';
import ReactSVG from 'react-svg';
import * as lib from '~/dependencies';
import { EmailIcon } from '~/assets/svgIcons';
import { AudioComponent } from './styles';

export default function Player({ audio, onDelete }) {
  const isAdmin = useSelector(state => state.auth?.isAdmin);

  const player = useRef(null);

  function onEnded() {
    if (player?.current?.audio) {
      player.current.audio.autoplay = false;
      player.current.audio.load();
      player.current.audio.pause();
      player.current.audio.currentTime = 0;
    }
  }

  return (
    <AudioComponent>
      <AudioPlayer
        ref={player}
        preload="none"
        autoPlay
        src={audio}
        onEnded={onEnded}
      />
      <ReactSVG
        src={EmailIcon}
        className={`delete-action${!isAdmin ? ' disabled' : ''}`}
        onClick={isAdmin ? () => onDelete() : undefined}
      />
    </AudioComponent>
  );
}

Player.defaultProps = {
  onDelete: () => {},
};

Player.propTypes = {
  audio: lib.PropTypes.string.isRequired,
  onDelete: lib.PropTypes.func,
};
